import { useSyncExternalStore } from "react";
import { consent, type ConsentSnapshot } from "./store";
import type { ConsentCategory } from "./types";

export interface UseConsentResult {
  /** Current consent state, or `null` when no decision has been made. */
  snapshot: ConsentSnapshot;
  /** Whether the user has made any consent decision yet. */
  hasDecision: boolean;
  /** Whether a category is currently granted (essential is always true). */
  isGranted: (category: ConsentCategory) => boolean;
  acceptAll: () => void;
  essentialOnly: () => void;
  setCategories: (
    partial: Partial<Record<ConsentCategory, boolean>>,
  ) => void;
}

/**
 * Subscribe a component to the device consent store. Re-renders on any consent
 * change, including cross-tab updates via the `storage` event.
 */
export function useConsent(): UseConsentResult {
  const snapshot = useSyncExternalStore(consent.subscribe, consent.get, consent.get);
  return {
    snapshot,
    hasDecision: snapshot !== null,
    isGranted: (category) =>
      category === "essential" || snapshot?.categories[category] === true,
    acceptAll: consent.acceptAll,
    essentialOnly: consent.essentialOnly,
    setCategories: consent.setCategories,
  };
}
